<template>
  <div style="text-align:center;">
    <Loading v-if="loading" />
    <h1>{{ apidata.system.self_upgrade_title }}</h1>
    <p>{{ apidata.system.self_upgrade_body }}</p>
     <p>{{ apidata.system.self_upgrade_body_line_2 }}</p>
    <p style="color:var(--secondary-color);font-weight:bold;">
      For assistance, please call a specialist at
      {{ apidata.system.booking_phone }}.
    </p>
    <div class="dashboard-booking-footer">
      If you need assistance, please call {{ apidata.system.booking_phone }}
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      loading: false,
    };
  },

  methods: {
    doAction: async function() {
      try {
        this.loading = true;
        const ticket_id = this.$route.query?.ticket_id;
        if (!ticket_id)
          throw new Error("This action requires a ticket ID in the URL.");

        await this.$axios({
          method: "post",
          url: "https://enrcv3w0p0qf10n.m.pipedream.net",
          params: {
            system_id: this.apidata.system.system_id,
            ticket_id,
            action: "self-upgrade",
          },
        });
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  created: async function() {
    await this.doAction();
  },
};
</script>
